<template>
  <div
    class="transition"
    v-if="props.in.typeEntite === 'entreprise'"
  >
    <BasicText size="h5">Entreprise non trouvée</BasicText>
    <div class="transition-items flex-1">
      <basic-text>
        Nous n’avons pas été en mesure de récupérer les informations sur votre entreprise auprès de l’INSEE pour le
        SIREN {{ props.in.sirenSiret }}. Merci de vérifier votre saisie ou contacter notre support téléphonique au
        {{ VITE_SUPPORT_TEL }} (horaires disponibles dans Aide & Contact)
      </basic-text>
      <BasicAlert
        alert-type="danger"
        alert-label="Le numéro SIREN est inconnu."
        class="flex-none"
      />
    </div>
  </div>
  <div
    class="transition"
    v-else
  >
    <BasicText size="h5">Établissement non trouvée</BasicText>
    <div class="transition-items flex-1">
      <basic-text>
        Nous n’avons pas été en mesure de récupérer les informations sur votre établissement auprès de l’INSEE pour le
        SIRET {{ props.in.sirenSiret }}. Merci de vérifier votre saisie ou contacter notre support téléphonique au
        {{ VITE_SUPPORT_TEL }} (horaires disponibles dans Aide & Contact)
      </basic-text>
      <BasicAlert
        alert-type="danger"
        alert-label="Le numéro SIRET est inconnu."
        class="flex-none"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
  import type { DemandeRattachementResult } from '@/features/interface/profil-utilisateur/rattachements/demande/types.ts'
  import type { CarteProps } from '@/features/interface/machine-etats/types.ts'
  import { VITE_SUPPORT_TEL } from '@/features/interface/shared/constants.ts'

  type In = Pick<DemandeRattachementResult, 'typeEntite' | 'sirenSiret'>
  type Out = void
  const props = defineProps<CarteProps<In, Out>>()
</script>

<style scoped lang="less">
  @import './ChoixCarte.less';

  .transition {
    max-width: 550px;
  }
</style>
